// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  token: undefined,
  user: {},
  rol: undefined,
  isLoaded: false,
  packages: true,
};

const actions = {
  register:
    (newUser, locale) =>
    ({ setState, getState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const storage = JSON.parse(localStorage.leo);
          const options = {
            method: 'POST',
            body: JSON.stringify(newUser),
            headers: {
              'Content-Type': 'application/json',
            },
          };
          const response = await fetch(`/api/auth/register?lang=${locale}`, options);
          const user = await response.json();
          if (response.status !== 200 && response.status !== 201) {
            reject(response.error ? response.error : user);
          } else {
            setState({ ...user, isLoaded: getState().isLoaded });
            localStorage.leo = JSON.stringify({
              ...getState(),
              currentLocale: storage.currentLocale,
            });
            resolve(true);
          }
        } catch (e) {
          reject(e);
        }
      }),
  login:
    (user) =>
    ({ setState, dispatch }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(user),
            headers: {
              'Content-Type': 'application/json',
            },
          };
          const response = await fetch('/api/auth/login', options);
          const userResponse = await response.json();
          if (response.status !== 200) {
            reject(userResponse.error);
          } else {
            setState({ token: userResponse.token });
            dispatch(actions.getUser()).then(
              (responserol) => {
                resolve(responserol);
              },
              (e) => reject(e)
            );
          }
        } catch (e) {
          reject(e);
        }
      }),
  setToken:
    (token) =>
    ({ getState, setState }) => {
      const storage = JSON.parse(localStorage.leo);
      if (getState().token !== token) {
        setState({ token });
        localStorage.leo = JSON.stringify({ ...getState(), currentLocale: storage.currentLocale });
      }
    },
  getUser:
    () =>
    ({ setState, getState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const storage = JSON.parse(localStorage.leo);
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${getState().token}`,
            },
          };

          const response = await fetch('/api/auth/get_active_user', options);
          const user = await response.json();

          if (response.status !== 200) {
            if (response.status === 401) {
              setState({
                token: undefined,
                user: {},
                isLoaded: true,
              });
              localStorage.leo = JSON.stringify({ currentLocale: storage.currentLocale });
            } else {
              reject(response.error);
            }
          } else if (
            (user.user.role_id === 3 ||
              user.user.role_id === 8 ||
              user.user.role_id === 4 ||
              user.user.role_id === 7 ||
              user.user.role_id === 9) &&
            user.user.id_status === 6
          ) {
            setState({ user: user.user });
            setState({ rol: user.user.role_id });
            localStorage.leo = JSON.stringify({
              ...getState(),
              currentLocale: storage.currentLocale,
            });
            resolve(getState().rol);
          } else {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      }),
  setAuth:
    () =>
    ({ getState, setState, dispatch }) => {
      if (!getState().token) {
        if (localStorage.leo) {
          const data = JSON.parse(localStorage.leo);
          setState({ ...data, isLoaded: false });
          dispatch(actions.getUser()).then(
            () => {
              setState({ isLoaded: true });
            },
            () => {
              localStorage.leo = JSON.stringify({ currentLocale: data.currentLocale });
            }
          );
        } else {
          setState({ isLoaded: true });
        }
      }
    },
  validateTokenRecoveryPassword: (token) => () =>
    new Promise(async (resolve, reject) => {
      try {
        const options = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const response = await fetch(`/api/auth/validate_token/${token}`, options);

        if (response.status !== 200) {
          reject(response);
        } else {
          resolve(true);
        }
      } catch (e) {
        reject(e);
      }
    }),
  changePassword:
    (newPassword, token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const storage = JSON.parse(localStorage.leo);
          const options = {
            method: 'POST',
            body: JSON.stringify(newPassword),
            headers: {
              'Content-Type': 'application/json',
            },
          };

          const response = await fetch(`/api/auth/change_password/${token}`, options);
          const user = await response.json();
          if (response.status !== 200 && response.status !== 201) {
            reject(response);
          } else {
            setState({ ...user, isLoaded: getState().isLoaded });
            localStorage.leo = JSON.stringify({
              ...getState(),
              currentLocale: storage.currentLocale,
            });
            resolve(true);
          }
        } catch (e) {
          reject(e);
        }
      }),
  getPackagesCompany:
    () =>
    ({ setState, getState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const storage = JSON.parse(localStorage.leo);
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${getState().token}`,
            },
          };

          const response = await fetch(
            '/api/bread/jwt/vehicles/static/search_vehicle_packages',
            options
          );
          const vehiclePackage = await response.json();

          if (response.status !== 200) {
            if (response.status === 401) {
              setState({
                token: undefined,
                user: {},
                isLoaded: true,
              });
              localStorage.leo = JSON.stringify({ currentLocale: storage.currentLocale });
            } else {
              reject(response.error);
            }
          } else if (vehiclePackage) {
            setState({ packages: vehiclePackage.planAvailable });

            localStorage.leo = JSON.stringify({
              ...getState(),
              currentLocale: storage.currentLocale,
            });
            resolve(getState().packages);
          } else {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      }),
  logout:
    () =>
    ({ setState, getState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${getState().token}`,
            },
          };
          const response = await fetch('/api/auth/logout', options);

          if (response.status !== 200) {
            if (response.status === 401) {
              setState({ token: '' });
            } else {
              reject(response.error);
            }
          } else {
            setState({ token: '' });
            resolve(true);
          }
        } catch (e) {
          reject(e);
        }
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'user',
});

export default createHook(Store);
